export enum EnumHospitalImportStatus {
  IMPORTING = "IMPORTING",
  PROCESSED = "PROCESSED",
  CANCELED = "CANCELED",
  ERROR = "ERROR",
}
